import axios from 'axios';
import { xray } from 'lib/xray';
import { PDFConverterAPICall } from 'reactApp/api/PDFConverterAPICall';
import { getExtension } from 'reactApp/modules/file/utils';
import { EStorageType } from 'reactApp/modules/storage/storage.types';

type Content = Buffer | null;

export const isBuffer = (data: any): data is Buffer => !!data?.byteLength;

export const downloadDocument = async (url: string, isStock = false, radars?: { onError: () => void; onSuccess: () => void }) => {
    try {
        let content;

        if (isStock) {
            const { data: response } = await axios.get<Content>(url, {
                withCredentials: true,
                params: { no_redirect: true },
                responseType: 'arraybuffer',
            });

            content = response;
        } else {
            const { data: response } = await axios.get(url, { withCredentials: true, params: { no_redirect: true } });
            const { data: file } = await axios.get<Content>(response.redirect, { responseType: 'arraybuffer' });
            content = file;
        }

        radars?.onSuccess();

        return { content };
    } catch (error: any) {
        radars?.onError();

        return { error };
    }
};

export const convertToPdfAndDownload = async (url: string, { storage, ext }: { storage: EStorageType; ext?: string }) => {
    const extension = ext || getExtension(url);

    xray.send(`ovidius_view_${storage}_${extension}`);

    try {
        const { data: content } = await new PDFConverterAPICall().makeRequest({ [storage]: url });

        xray.send(`ovidius_view-success_${storage}_${extension}`);

        return { content };
    } catch (error: any) {
        xray.send(`ovidius_view-error_${storage}_${extension}`);

        return { error };
    }
};
